/**
 * Kicker — shared aspect. Editorial-voice eyebrow label, rendered
 * in uppercase amber tracked spacing. Optionally preceded by a
 * short amber hairline rule.
 *
 * Used by EditorialIntro, WorkspaceHero, and any surface that
 * wants a small accent label above a Cormorant headline.
 */
import { Text, View } from "react-native";

import type { PaneTheme } from "../brand/paneThemes";

export type KickerProps = {
  theme: PaneTheme;
  label: string;
  /** Default true. Set false for a label-only eyebrow without the
   *  leading amber hairline rule. */
  showHairline?: boolean;
  /** Hairline width in px. Default 28. */
  hairlineWidth?: number;
};

export function Kicker({
  theme,
  label,
  showHairline = true,
  hairlineWidth = 28,
}: KickerProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
      }}
    >
      {showHairline ? (
        <View
          style={{
            height: 1,
            width: hairlineWidth,
            backgroundColor: theme.accent,
          }}
        />
      ) : null}
      <Text
        style={{
          fontFamily: theme.bodyBoldFont,
          fontSize: 10,
          letterSpacing: 2.2,
          textTransform: "uppercase",
          color: theme.accent,
        }}
        numberOfLines={1}
      >
        {label}
      </Text>
    </View>
  );
}
